export const fs = {
  enabled:
    document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled,
  element: () =>
    document.fullscreenElement ||
    document.webkitCurrentFullScreenElement ||
    document.mozFullScreenElement,
  request: (node) => {
    if (node.requestFullscreen) {
      node.requestFullscreen().catch((error) => {
        console.warn(error);
      });
    } else if (node.webkitRequestFullScreen) {
      node.webkitRequestFullScreen();
    } else if (node.mozRequestFullScreen) {
      node.mozRequestFullScreen();
    }
  },
  exit: () => {
    if (document.exitFullscreen) {
      document.exitFullscreen().catch((error) => {
        console.warn(error);
      });
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    }
  },
  onChange: (fn) => {
    if (typeof document.onfullscreenchange !== 'undefined') {
      document.addEventListener('fullscreenchange', fn, false);
    } else if (typeof document.onwebkitfullscreenchange !== 'undefined') {
      document.addEventListener('webkitfullscreenchange', fn, false);
    } else if (typeof document.onmozfullscreenchange !== 'undefined') {
      document.addEventListener('mozfullscreenchange', fn, false);
    }
  },
};
